// /service/events_service/v1/events/admin/event/list/6715f693e50e01850da4a768

import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getEventsData = async (id) => {
  try {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/service/events_service/v1/events/admin/event/live_upcoming`,
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
      params: { vendor_id: id }
    };
    const response = await axios.request(config);
    return response?.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export default getEventsData;
